import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useBreakpoints } from "../../hooks/useBreakpoints";

const AppCard = ({
  colorBg,
  img,
  subTitle,
  styleSubTitle,
  title,
  styleTitle,
  secondaryTitle,
  description,
  link,
  textBtn,
  withPoup,
}) => {
  const { lg } = useBreakpoints();
  return (
    <div
      className={`app-card pb-[52px] lg:relative overflow-hidden  ${
        withPoup ? "h-[339px] xl:h-[480px]" : "lg:h-[518px] xl:h-[h-568px]"
      } ${colorBg}`}
    >
      <div
        className={`bg-cover bg-center bg-no-repeat w-full ${
          withPoup ? "h-[192px] lg:h-[339px]" : "h-[182px] lg:h-[317px]"
        }`}
        style={{
          backgroundImage: `url(${img})`,
        }}
      />
      <div className="app-card__overlay lg:absolute lg:top-0 lg:left-0 lg:w-full lg:h-full lg:transition-all lg:duration-500">
        <div
          className={`app-card__content items-center grid pb-7 pt-[42px] ps-[27px] pe-[27px] lg:absolute lg:transition-all lg:duration-500 ${
            withPoup
              ? "lg:top-[58%] xl:top-[56%] 2xl:top-[59%]"
              : "lg:top-[58%] xl:top-[56%] 2xl:top-[59%]"
          }`}
        >
          <p className={`text-lg font-bold mb-[10px]  ${styleSubTitle}`}>
            {subTitle}
          </p>
          <h2
            className={`font-oswald mb-[30px] lg:mb-[65px] leading-[37.5px] text-night-blue lg:w-[412px] ${styleTitle}`}
          >
            {title}
            <span className="lg:block">{secondaryTitle}</span>
          </h2>
          {!withPoup || lg ? (
            <p className="leading-[21px] mb-[30px]">{description}</p>
          ) : (
            " "
          )}

          {textBtn && link ? (
            <Link
              to={link}
              className="app-button bg-night-blue text-creamy-beige hover:bg-creamy-beige hover:text-night-blue"
            >
              {textBtn}
            </Link>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default AppCard;
